import { gql } from 'graphql-request';

export const createShopifyMenuQuery = (handle) => {
    return gql`{
  menu(handle: "${handle}") {
    items {
      items {
        id
        resourceId
        title
        type
        url
        items {
            id
            resourceId
            title
            type
            url
          }
      }
      id
      title
      url
      type
      resourceId
    }
  }
}`
};
